// extracted by mini-css-extract-plugin
export default {"root":"applications-components-common-Price-prices-module__root","basePrice":"applications-components-common-Price-prices-module__basePrice","currentPrice":"applications-components-common-Price-prices-module__currentPrice","sale":"applications-components-common-Price-prices-module__sale","saleLabel":"applications-components-common-Price-prices-module__saleLabel"};
    if(module.hot) {
      // 1791528100347
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  